<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center pt-0>
      <v-flex>
        <v-tabs
          fixed-tabs
          v-model="tabValue"
          color="#FDAC53"
          centered
          slider-color="yellow"
        >
          <v-tab v-for="item in titleArray" :key="item.value">
            {{ item.title }}
          </v-tab>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-tabs-items v-model="tabValue">
      <!-- <template v-for="(item, index) in titleArray"> -->
      <v-tab-item>
        <!-- <v-layout wrap justify-center pt-4>
            <v-flex xs1 hidden-md-and-down></v-flex>
            <v-flex
              pa-2
              v-for="(cat, i) in categories"
              :key="i"
              text-center
              align-self-center
            >
              <v-btn
                block
                text
                :ripple="false"
                @click="getPrograms(item.value, cat._id)"
              >
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 12px;
                    color: #343434;
                    text-transform: none;
                  "
                >
                  {{ cat.name }}
                </span>
              </v-btn>
            </v-flex>
            <v-flex xs1 hidden-md-and-down></v-flex>
          </v-layout> -->
        <Listed :products="products" @stepper="winStepper"></Listed>
      </v-tab-item>
      <!-- <v-tab-item>
        <Pending :products="pendingProducts" @stepper="winStepper"></Pending>
      </v-tab-item>
      <v-tab-item>
        <Updated :products="products" @stepper="winStepper"></Updated>
      </v-tab-item>
      <v-tab-item>
        <Rejected :products="products" @stepper="winStepper"></Rejected>
      </v-tab-item> -->
      <!-- </template> -->
    </v-tabs-items>
  </div>
</template>
<script>
import axios from "axios";
import Listed from "./activeProducts";
// import Pending from "./pendingProducts";
// import Updated from "./updatedProducts";
// import Rejected from "./rejectedProducts";
export default {
  components: {
    // Updated,
    // Pending,
    Listed,
    // Rejected,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      categories: [],
      products: [],
      pendingProducts: [],
      currentPage: 1,
      tabValue: 0,
      titleArray: [
        // { title: "APPROVED", value: "approved" },
        // { title: "PENDING", value: "pending" },
        // { title: "UPDATES", value: "updates" },
        // { title: "REJECTED", value: "rejected" },
      ],
    };
  },
  watch: {
    tabValue() {
      if (this.tabValue == 0) this.getProduct();
      // else if (this.tabValue == 1) this.getPendingProduct();
      // else if (this.tabValue == 2) this.getUpdatedProduct();
      // else if (this.tabValue == 3) this.getRejectedProduct();
    },
  },
  beforeMount() {
    this.getProduct();
  },
  methods: {
    winStepper(window_data) {
      var w=window_data
      window_data=w
    },
    getProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          userid: this.$route.query.seller,
          limit: 12,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.products = response.data.data;
            this.totalCount = response.data.count;
            this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getPendingProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          // from: this.fromDate,
          // to: this.toDate,
          // user: this.programme,
          // slotDetail: this.slotDetail,
          uid: this.$route.query.seller,
          productStatus: "Pending",
          count: 12,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.sellers = response.data.data;
            // this.reservationData = response.data.reservations;
            this.pages = response.data.pages;

            // this.excel = response.data.data;
            // this.json_data = this.excel;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getUpdatedProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/updated/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          uid: this.$route.query.seller,
          count: 12,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.products = response.data.data;
            this.totalCount = response.data.count;
            this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getRejectedProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          // from: this.fromDate,
          // to: this.toDate,
          // user: this.programme,
          // slotDetail: this.slotDetail,
          uid: this.$route.query.seller,
          productStatus: "Rejected",
          count: 12,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.sellers = response.data.data;
            // this.reservationData = response.data.reservations;
            this.pages = response.data.pages;

            // this.excel = response.data.data;
            // this.json_data = this.excel;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>